import React, { createContext, useContext, useMemo } from 'react';
import type { FontSizeConfig } from '../utils/types';
import { FONT_SIZE_CLASS } from '../utils/types';

interface FontSizeContextValue {
  heading: string;
  body: string;
  small: string;
}

const FontSizeContext = createContext<FontSizeContextValue>({
  heading: 'text-sm',
  body: 'text-sm',
  small: 'text-xs',
});

export function FontSizeProvider({
  config,
  children,
}: {
  config?: FontSizeConfig;
  children: React.ReactNode;
}) {
  const value = useMemo(
    () => ({
      heading: FONT_SIZE_CLASS[config?.heading ?? 'sm'],
      body: FONT_SIZE_CLASS[config?.body ?? 'sm'],
      small: FONT_SIZE_CLASS[config?.small ?? 'xs'],
    }),
    [config?.heading, config?.body, config?.small],
  );

  return <FontSizeContext.Provider value={value}>{children}</FontSizeContext.Provider>;
}

export function useFontSizes() {
  return useContext(FontSizeContext);
}
